import { Button, Modal } from "antd";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import {
  currentDate,
  ERROR_CODE_TIMOUT,
  TYPE_USER,
} from "../helper/const";
import { setReduxDataTypeIntroTour } from "../Redux/futures/home/actions";
import { useDispatch, useSelector } from "react-redux";
import { curStateHome } from "../Redux/selector";
import { useEffect, useState } from "react";
import PopupFrame from "./popups/ui-1";
import Buttons from "./popups/Buttons";

function ModalNotiPackageErrorNewUser({
  isContainer = false,
  open,
  title = "",
  handleCancel,
  message,
  errorCode,
  topIcon
}) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const selectorHome = useSelector(curStateHome);
  const [currentProduct, setCurrentProduct] = useState([]);
  useEffect(() => {
    if (selectorHome?.bidProduct?.length > 0) {
      let currentProduct = selectorHome.bidProduct.filter(
        (product) => new Date(product?.start_time).getTime() < currentDate
      );
      setCurrentProduct(currentProduct);
    } else {
      setCurrentProduct([]);
    }
  }, [selectorHome.bidProduct]);

  const handleBid = () => {
    handleCancel();
    dispatch(
      setReduxDataTypeIntroTour({
        typeActive: TYPE_USER.newDeeplink,
        step: 1,
      })
    );
  };

  return (
    <PopupFrame
      title={title}
      open={open}
      onOpenChange={handleCancel}
      className="modal-notifycation"
      centered
      getContainer={isContainer ? false : null}
      width={684}
      // footer={
      //   <div style={{ textAlign: "center" }}>
      //     <Button onClick={handleBid} className="button-foot-modal">
      //       {t('user_guide.use_free_turn')}
      //     </Button>
      //     <div onClick={handleCancel} style={{ marginTop: "20px" }}>
      //       {t('user_guide.try_again')}
      //     </div>
      //   </div>
      // }
    >
      <div className="modal-notifycation-body">
        {topIcon && (
          <img
            src={topIcon}
            alt=""
            className="mx-auto mb-4 w-[55%] max-w-60 object-contain"
          />
        )}
       <div className="w-full flex flex-col gap-2 text-center">
          <div className="text-[#6E4A21] text-[17px] sm:text-[20px] font-semibold">
            {message}
          </div>
        </div>
        {+errorCode === ERROR_CODE_TIMOUT ? (
          <div className="w-full flex flex-col gap-2 text-center">
          <div className="text-[#6E4A21] text-[17px] sm:text-[20px] font-semibold">
            {
              t("user_guide.timeout", {
                returnObjects: true,
              })[0]
            }
          </div>
        </div>
        ) : (
          <></>
        )}
        <div className="w-full flex flex-col gap-2 text-center">
          <div className="text-[#6E4A21] text-[17px] sm:text-[20px] font-semibold">
          {t('user_guide.timeout', {returnObjects: true})[1]}
          {t('user_guide.timeout', {
            returnObjects: true,
          })[2].replace(
            "[product_name]",
            currentProduct[0]?.product_name || "")}
        </div>
        </div>
      </div>

      <div style={{ textAlign: "center" }}>
          <Buttons handleClick={handleBid} classItem="!mb-0" textBtn = {t('user_guide.use_free_turn')}>
            {/* {t('user_guide.use_free_turn')} */}
          </Buttons>
          <div onClick={handleCancel} style={{ marginTop: "20px" }}>
            {t('user_guide.try_again')}
          </div>
        </div>
    </PopupFrame>
  );
}

const Container = styled(Modal)`
  .modal-notifycation-body {
    text-align: inherit;
    flex-direction: column;
    gap: 20px;
    justify-content: start;
    align-items: inherit;
  }

  .button-foot-modal {
    text-align: center;
  }
`;

export default ModalNotiPackageErrorNewUser;
